<template>
    <span class="badge" :style="style">
        <slot />
    </span>
</template>

<script>
export default {
    props: {
        backgroundColour: {
            type: String,
            default: '',
        },
        textColour: {
            type: String,
            default: '',
        },
    },
    computed: {
        style() {
            return {
                backgroundColor: this.backgroundColour,
                color: this.textColour,
            };
        },
    },
};
</script>

<style scoped>

</style>
